const SIGLA_TO_LOCALE: Record<string, string> = {
  BRL: 'pt-BR',
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
  JPY: 'ja-JP',
  CLP: 'es-CL',
  PEN: 'es-PE',
  COP: 'es-CO',
  MXN: 'es-MX',
  CAD: 'en-CA',
};

export const formatValorMoeda = (
  valor: number | null | undefined,
  sigla: string,
): string => {
  if (valor == null || Number.isNaN(valor)) return '—';
  const locale = SIGLA_TO_LOCALE[sigla] ?? 'pt-BR';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: sigla || 'BRL',
    }).format(valor);
  } catch {
    return `${sigla} ${valor.toFixed(2)}`;
  }
};

export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
};
